export default {
      //获取路由名称
      getRouterName(states) {
        return states.routerName;
    },
    //判断loginModal的显示与隐藏
    getLoginStatus(status) {
        return status.loginStatus
    },
    //获取个人信息
    getUserInfo(states) {
        return states.userInfo;
    }
}




// WEBPACK FOOTER //
// ./src/store/navigation/getters.js